import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { useTipoExameService } from 'hooks/useTipoExameService'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import useRouter from 'utils/useRouter'

import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Exames = (props) => {
  const { route } = props
  const router = useRouter()
  const tipoExameService = useTipoExameService()
  const classes = useStyles()

  const exames = useSelector((state) => state.exames.exames)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    tipoExameService.listarTiposExamesGlobal()


  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header
        titulo={`${route.secao} cadastrados`}
        overline={route.secao}
        textoBotao="Cadastrar novo"
        linkBotao={`${route.path}/cadastrar`}
      />
      {exames && <Results className={classes.results} dados={exames} />}
    </Page>
  )
}
